import { render, staticRenderFns } from "./BCXMessengerGroup.vue?vue&type=template&id=2688b76e&scoped=true"
import script from "./BCXMessengerGroup.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerGroup.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerGroup.vue?vue&type=style&index=0&id=2688b76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688b76e",
  null
  
)

export default component.exports